<template>
    <div class="range-page">
        <img v-show="!isShowSelector" class="range-header-bg" src="~@/assets/images/range/range_bg.png" alt="服务范围查询banner图片" />
        <!-- 头部-地区选择 -->
        <section class="sel-reigin" @click="toggleSelector">
            <label v-show="!isShowSelector">
                <span class="txt" :class="{ active: areaName !== '国家/地区选择' }">{{ areaName }}</span>
                <i class="caret-right"></i>
            </label>
        </section>
        <!-- 结果显示 -->
        <template v-if="!isShowSelector">
            <section v-if="isShowResult" class="rst-range">
                <!-- 服务概况 -->
                <div class="pane">
                    <div v-if="isAllService || (isInternational && !isUSA)" class="tip all-range">
                        <i class="icon-all-range"></i>{{ _ll('全境支持服务') }}
                    </div>
                    <template v-else>
                        <div class="tip part-range"><i class="icon-part-range"></i>{{ _ll('部分地区支持服务，不支持服务的地区：') }}</div>
                        <div v-if="rangeData.unavailableRegions && rangeData.unavailableRegions.length > 0" class="tip part-range">
                            {{ unavailableRegionsNames }}
                        </div>
                        <div v-if="isUSA" class="tip part-range">
                            快件进口 - 进口派送服务覆盖全美50个州份。<br /><br />
                            快件出口 - 顺丰速运提供全美48个州（不包含夏威夷和阿拉斯加）的快件出口服务。具体的服务内容请联系美国销售组和客服组：<br /><br />
                            美国销售组： US_SALES_@sf-express.com <br /><br />
                            美国客服组：US_CSD_GROUP@sf-express.com
                        </div>
                    </template>
                </div>
            </section>
            <section v-else class="rst-range">
                <div class="tip">顺丰寄送服务全年无休，我们将竭尽全力为您提供优质服务</div>
            </section>
        </template>
        <!-- 城市选择 -->
        <overlay
            :class="selectClass"
            :isShow.sync="isShowSelector"
            :finished.sync="selectCompleted"
            :enableBtn="enableBtn"
            :hasValid="hasSelectValidator"
            :cbValid="validSelector"
        >
            <h3 class="head">地区选择</h3>
            <ul class="rgn-tab">
                <li v-for="(item, idx) in regionTabs" :key="item.id" @touchstart.stop="toggleTab(idx)">
                    <div class="btn-tab" :class="{ active: regionTabIndex === idx }">{{ item.name }}</div>
                </li>
            </ul>
            <div class="search-form">
                <input
                    v-model="inputTxt"
                    type="text"
                    class="search"
                    :placeholder="placeholderTxt"
                    @input="inputChange"
                    @click="searchInputFocus"
                    @blur="searchInputBlur"
                />
                <i class="icon-search"></i>
                <i v-if="inputTxt" class="icon-close" @click.prevent="clear"></i>
            </div>
            <form class="m-from" @submit.prevent="submitSelect">
                <div v-if="!searchAddressList.length">
                    <div v-if="regionTabIndex === 0">
                        <area-inland :updateAreaCode="updateAreaCode" :updateSelect="updateSelect" />
                    </div>
                    <div v-if="regionTabIndex === 1">
                        <area-hmt :updateAreaCode="updateAreaCode" :updateSelect="updateSelect" :provinces="intlProvinces" />
                    </div>
                    <div v-if="regionTabIndex === 2">
                        <area-intl
                            :input.sync="inputTxt"
                            :updateAreaCode="updateAreaCode"
                            :zipCode="zipCode"
                            :updateZipCode="val => (zipCode = val)"
                            :updateSelect="updateSelect"
                            :provinces="intlProvinces"
                        />
                    </div>
                </div>
                <ul v-else class="search-address-region">
                    <li
                        v-for="(item, index) in searchAddressList"
                        :key="index"
                        :class="{ active: index === selectedItemIndex }"
                        @click="selectedSearchAddress(item, index)"
                        v-html="item.html"
                    ></li>
                </ul>
            </form>
            <slot slot="button" slot-scope="props">
                <div ref="btnConfirm" class="btn-confirm" :class="{ active: props.active }">
                    <span>确认</span>
                </div>
            </slot>
        </overlay>
    </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import { RegionGroup } from '@/constant/common'
import ibuCountry from '@/constant/ibuCountry'
import InlandCitySelector from '@/components/citySelector/area-inland'
import IntlCitySelector from '@/components/citySelector/area-intl'
import HMTCitySelector from '@/components/citySelector/area-hmt'
import Overlay from '@/components/citySelector/overlay/'
import ajax from '../../api/ajax'
import { Indicator } from 'mint-ui'
import _ from 'lodash'
import mixCitySelector from '@/components/citySelector/mixin'
import UIP from '@/util/uip.js'
import { getHighHtml } from '@/util/util.js'

export default {
    name: 'Range',
    components: {
        'area-inland': InlandCitySelector,
        'area-intl': IntlCitySelector,
        'area-hmt': HMTCitySelector,
        overlay: Overlay
    },
    data() {
        return {
            isShowSelector: false, // 是否显示城市选择框
            enableBtn: false, // 选择结束，激活按钮
            selectCompleted: false, // 选择是否完成
            regionTabIndex: 0, // 范围选择项(大陆、港澳台、国际)
            selectorValidResult: '', // 选择器验证结果
            isShowResult: false,
            rangeData: {
                unavailableRegions: [], // 不服务地区
                normalRegions: [], // 正常收送地区
                abnormalRegions: [], // 特别收送地区
                type: '' // ALL_REGION,全境提供服务; PART_REGION,部分地区提供服务;
            },
            ibuCountryCode: '',
            areaName: '国家/地区选择', // 选择地址名
            zipCode: '',
            areaCode: '',
            countryList: [], // 同步cx已开放的国际国家json数据
            intlProvinces: [], // 国际城市信息
            inputTxt: '', // 搜索框输入文案
            searchAddressList: [], // 搜索结果列表
            selectedItemIndex: -1, // 搜索结果选中索引
            selectClass: '', // 下拉选框className
            screenHeight: document.documentElement.clientHeight || document.body.clientHeight // 这里是给到了一个默认值
        }
    },
    computed: {
        ...mapGetters('range', {
            getAreaData: 'getAreaData'
        }),
        regionTabs() {
            return RegionGroup.regionTabs
        },
        isAllService() {
            return this.rangeData.type === 'ALL_REGION'
        },
        unavailableRegionsNames() {
            const names = this.rangeData.unavailableRegions.map(item => item.name)
            return names.join('-')
        },
        isInternational() {
            return this.regionTabIndex === 2
        },
        isUSA() {
            return this.areaCode === 'A000001000'
        },
        hasSelectValidator: {
            // 选择器是否有验证规则
            get() {
                return this.isInternational
            }
        },
        /**
         * 根据范围选择项动态匹配输入框默认文案
         */
        placeholderTxt() {
            return (
                new Map([
                    [0, '请输入地区名进行搜索'],
                    [1, '请输入地区名进行搜索'],
                    [2, '请输入国家名进行搜索']
                ]).get(this.regionTabIndex) || '请输入地区名进行搜索'
            )
        },
        /**
         * 行政区的 regionKey
         */
        regionKey() {
            return (
                new Map([
                    [0, 'local_region_cn_sc'],
                    [1, 'local_region_hk_mo_tw_sc'],
                    [2, 'local_ibu_hotcounties_sc']
                ]).get(this.regionTabIndex) || 'local_region_cn_sc'
            )
        }
    },
    watch: {
        selectCompleted(val) {
            if (val && !this.isInternational) {
                this.getRange()
            }
        },
        inputTxt(val) {
            if (!val) {
                this.clear()
            }
        },
        regionTabIndex(val) {
            // 大陆和港澳台通过uip查询，国际直接从已有数据中筛选
            if (val === 2) {
                return (this.searchAddressList = [])
            }
            if (this.inputTxt) {
                this.inputChange()
            }
        },
        isShowSelector(val) {
            // 重新打开窗口清空搜索记录
            if (val) {
                return (this.inputTxt = '')
            }
            this.selectedItemIndex = -1
        }
    },
    mixins: [mixCitySelector],
    beforeCreate() {
        this.$store.commit('setTitle', this._ll('收寄范围'))
    },
    created() {
        // 获取国外已开放国家js数据
        this.countryList = ibuCountry.countryList
        // 取出国家code码，与接口返回的国际国家数据取交集，使用接口返回的国家数据
        const countryCodeList = []
        this.countryList.forEach(value => {
            countryCodeList.push(value.code)
        })
        this.getRegion({ code: 'A000000000' }).then(provinces => {
            const countryArray = provinces.filter(value => countryCodeList.indexOf(value.rateCode) > -1)
            this.intlProvinces = countryArray
        })
        this.setShowCustomer(true)
    },
    mounted() {
        window.addEventListener('resize', this.resizeHeight, false)
    },
    beforeDestroy() {
        // 销毁前解绑
        window.removeEventListener('resize', this.resizeHeight, false)
    },
    methods: {
        ...mapMutations('range', {
            setSelectorValid: 'setSelectorValid',
            setAreaData: 'setAreaData'
        }),
        ...mapMutations(['setShowCustomer']),
        /**
         * 模糊匹配
         */
        inputChange: _.debounce(async function () {
            if (this.inputTxt.length >= 2 && !this.isInternational) {
                const options = {
                    regionKey: this.regionKey,
                    count: '1000'
                }
                this.$loading('加载中')
                // this.searchAddressList = await this.$I.region.search(this.inputTxt, options)
                this.searchAddressList = await UIP.interface.region.search(this.inputTxt, options)
                this.searchAddressList.forEach(item => {
                    const str = [item.province, item.city, item.county].filter(item => !!item).join('-')
                    item.html = getHighHtml(str, this.inputTxt)
                    item.cityCode = item.countyAreaCode || ''
                    item.countyCode = item.countyAreaCode || ''
                    item.locationCode = item.countyLocationCode || item.cityLocationCode || item.provinceLocationCode || ''
                    item.provinceCode = item.provinceAreaCode || ''
                })
                this.$loading()
                if (!this.searchAddressList.length) {
                    this.$toast('对不起，查询不到数据')
                }
            }
        }, 500),
        /**
         * 清空搜索数据
         */
        clear() {
            this.inputTxt = ''
            this.selectedItemIndex = -1
            this.searchAddressList = []
            this.selectedProvince = {}
            this.selectedAreaType = 'province'
            if (this.selectedItemIndex !== -1) {
                this.setAreaData({})
            }
        },
        /**
         * 选中某一项返回接口查询结果
         */
        selectedSearchAddress(item, index) {
            this.enableBtn = true
            this.selectedItemIndex = index
            // 澳门-环路可能只有两级 如果没有 countryCode 则取 cityCode
            this.areaCode = item.countyCode || item.cityCode
            const resultCounty = item.county ? `-${item.county}` : ''
            this.areaName = `${item.province}-${item.city}${resultCounty}`
            // uip查询结果和接口返回结构不同，这里需要对省市区三级重新做赋值
            this.setAreaData({
                province: {
                    name: item.province,
                    code: item.provinceCode
                },
                city: {
                    name: item.city,
                    code: item.cityCode
                },
                country: {
                    name: item.county,
                    code: item.countyCode
                }
            })
        },
        submitSelect() {
            const event = document.createEvent('Events')
            event.initEvent('touchstart', true, true)
            this.$refs.btnConfirm.dispatchEvent(event)
        },
        async validSelector() {
            let valid = false
            if (this.isInternational) {
                const code = this.zipCode
                valid = await this.validSelectorIntl(code)
            }
            if (!valid) {
                // 验证没有通过， 重置状态（选择未完成）
                this.selectCompleted = false
                this.enableBtn = false
            }
            this.setSelectorValid(valid)
            return valid
        },
        async validSelectorIntl(code) {
            /**
             * @author 80004302
             * @desc 国际范围查询邮编后端验证ZipCode, 验证失败，则重置选择组件的验证状态
             */
            let valid = false
            valid = await this.getGlobalRange(code)
            if (!valid) {
                this.areaName = '国家/地区选择'
            }
            return valid
        },
        updateAreaCode({ code, areaName, rateCode, countryCode }) {
            this.areaCode = code
            this.areaName = areaName
            this.ibuCountryCode = rateCode || ''
        },
        updateSelect(val) {
            this.enableBtn = !!val
        },
        toggleTab(index) {
            if (this.regionTabIndex !== index) {
                this.enableBtn = false
                this.setAreaData({})
            }
            this.regionTabIndex = index
            this.selectedItemIndex = -1
        },
        toggleSelector() {
            this.isShowSelector = true
            // this.enableBtn = false
        },
        getRange() {
            const areaCode = this.areaCode
            Indicator.open()
            ajax.getInternalRange({
                params: {
                    areaCode
                }
            })
                .then(res => {
                    this.rangeData = res.data
                    this.isShowResult = true
                })
                .catch(() => {
                    this.isShowResult = false
                })
                .finally(() => {
                    Indicator.close()
                })
        },
        async getGlobalRange(code) {
            let valid = false
            Indicator.open()
            try {
                const res = await ajax
                    .queryPostCodeInfo({
                        params: {
                            countryCode: this.ibuCountryCode,
                            countryName: this.areaName,
                            postCode: code,
                            queryMode: 1
                        }
                    })
                    .catch(err => {
                        if (err.response && (err.response.status === 404 || err.response.status === 403 || err.response.status === 0)) {
                            this.$toast('对不起，查询不到数据')
                        } else {
                            this.$toast('服务器暂不可用，请稍后再试')
                        }
                    })
                this.rangeData = res.data
                let areaName = [this.areaName, this.zipCode].join('-')
                if (areaName.endsWith('-')) {
                    areaName = areaName.slice(0, -1)
                }
                this.areaName = areaName
                valid = true
                this.isShowResult = true
            } catch (e) {
                valid = false
                this.isShowResult = false
            }
            Indicator.close()
            return valid
        },
        async getRegion({ code, level = -1 }) {
            // 获取国际省份信息
            const { data } = await ajax.getOriginRegions({
                lang: 'sc',
                regiion: 'cn',
                translate: 'sc',
                data: {
                    code
                },
                params: {
                    level: -1
                }
            })
            return data
        },
        // 点击输入框时处理安卓 键盘挡住问题
        searchInputFocus() {
            const timerFocus = setTimeout(() => {
                timerFocus && clearTimeout(timerFocus)
                this.selectClass = 'select-rel'
                document.body.scrollTop = 0
                // 如果document.body.scrollTop始终为0，用document.documentElement.scrollTop代替
                document.documentElement.scrollTop = 0
                window.scrollTo && scrollTo(0, 0)
            }, 500)
        },
        searchInputBlur() {
            const timerBlur = setTimeout(() => {
                timerBlur && clearTimeout(timerBlur)
                this.selectClass = ''
            }, 500)
        },
        /**
         * 页面resize响应的事件函数
         * **/
        resizeHeight() {
            const winScreenHeight = document.documentElement.clientHeight || document.body.clientHeight
            if (winScreenHeight > this.screenHeight) {
                // 键盘收起
                this.selectClass = ''
            }
            this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight
        }
    }
}
</script>

<style lang="scss" scoped>
.range-page {
    background: #f3f3f3;
    .range-header-bg {
        width: 100%;
    }
    .sel-reigin {
        padding: 0 0.3rem;
        line-height: 1rem;
        background: #fff;
        label {
            display: flex;
            align-items: baseline;
            position: relative;
            top: -0.6rem;
        }
        .title {
            font-weight: 600;
        }
        .txt {
            background: #fff;
            display: inline-block;
            color: #868686;
            text-align: left;
            flex: 1;
            margin-right: 0.2rem;
            border: 1px solid #d9d9d9;
            border-radius: 0.08rem;
            box-shadow: 0 0.1rem 0.24rem 0 rgba(0, 0, 0, 0.06);
            padding-left: 0.24rem;
            padding-right: 0.3rem;
            &.active {
                color: $black;
            }
        }
        .caret-right {
            position: absolute;
            top: 50%;
            right: 0.5rem;
            margin-top: -0.06rem;
            width: 0;
            height: 0;
            border: 0.11rem solid transparent;
            border-top: 0.11rem solid black;
        }
    }
    .overlay-service {
        position: fixed;
        top: 70%;
        right: 0.1rem;
        width: 1rem;
        height: 1rem;
        background-color: #fff;
        box-shadow: 0 0 0.13rem 3px rgba(0, 0, 0, 0.1);
        padding: 0.1rem 0;
        z-index: 10;
        >>> a {
            display: block;
            width: 100%;
        }
        p {
            font-size: 5px;
            color: 666;
            &::before {
                content: '';
                display: block;
                width: 0.5rem;
                height: 0.5rem;
                margin: 0 0 0 auto;
                background: url('~@/assets/images/logo/sf-logo.png') 0 0 / 0.4rem 0.4rem no-repeat;
            }
        }
    }
    .rgn-tab {
        li {
            display: inline-block;
            width: 33.3%;
            text-align: center;
            line-height: 2;
            padding: 0.2rem;
        }
        .btn-tab {
            width: 80%;
            margin: 0 auto;
            background: #fff;
            border-radius: 0.3rem;
            font-size: 0.26rem;
            box-sizing: border-box;
            border: solid 0.01rem #e4e4e4;
            &.active {
                color: #dc1e32;
                border: solid 0.01rem #dc1e32;
                background: #fff;
            }
        }
    }
    .rst-range {
        padding: 0 0.71rem 0 0.64rem;
        background: $white;
        .tip {
            font-size: 0.26rem;
            line-height: 0.52rem;
            color: #888888;
            text-align: left;
            &.all-range {
                font-size: 0.3rem;
                line-height: 0.6rem;
                color: #0dbf0b;
                .icon-all-range {
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.36rem;
                    height: 0.36rem;
                    background: url('~@/assets/svg/all-range.svg') center / cover;
                    margin-right: 0.11rem;
                    margin-top: -0.06rem;
                }
            }
            &.part-range {
                font-size: 0.28rem;
                line-height: 0.6rem;
                color: #dc1e32;
                .icon-part-range {
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.36rem;
                    height: 0.36rem;
                    background: url('~@/assets/svg/part-range.svg') center / cover;
                    margin-right: 0.11rem;
                    margin-top: -0.06rem;
                }
            }
        }
        .pane {
            margin-bottom: 0 0.3rem;
        }
    }
    h3 {
        padding: 0.3rem;
        text-indent: 2ch;
        font-size: 0.3rem;
        color: #111111;
        font-weight: 800;
        box-shadow: 0 1px 0 0 #f2f2f2;
    }
    h5 {
        font-size: 0.26rem;
        color: #333333;
        font-weight: bold;
        line-height: 3;
        width: 100%;
    }
    -webkit-overflow-scrolling: touch;
}
.btn-confirm {
    padding: 0.2rem.5rem;
    >>> span {
        display: inline-block;
        width: 100%;
        border-radius: 0.48rem;
        text-align: center;
        color: #fff;
        font: bold 0.34rem/3 YaHei;
        letter-spacing: 0.5rem;
        text-indent: 0.5rem;
        background: rgba(0, 0, 0, 0.3);
    }
    &.active {
        >>> span {
            background: #dc1e32;
            color: #ffffff;
        }
    }
}
::-webkit-scrollbar {
    display: none;
}
.search-form {
    position: relative;
    margin: 0.2rem 0.3rem 0;
    width: calc(100% - 0.6rem);
    height: 0.64rem;
    .icon-search {
        position: absolute;
        display: inline-block;
        left: 0.2rem;
        top: 0.18rem;
        width: 0.32rem;
        height: 0.32rem;
        background: url('~@/assets/images/ico/icon-search-gray.png') no-repeat;
        background-size: cover;
    }
    .icon-close {
        position: absolute;
        display: inline-block;
        right: 0.3rem;
        top: 0.18rem;
        width: 0.3rem;
        height: 0.3rem;
        background: url('~@/assets/images/ico/icon-close-new.png') no-repeat;
        background-size: cover;
    }
}
input[type='text'] {
    position: relative;
    padding: 0 0.7rem 0 0.57rem;
    border: none;
    font-size: 0.26rem;
    color: $black;
    background-color: $bg-color;
    border-radius: 0.32rem;
    line-height: 0.64rem;
}
.search-address-region {
    padding-top: 0.32rem;
    max-height: 7rem;
    overflow-y: scroll;
    li {
        width: 100%;
        min-height: 0.96rem;
        line-height: 0.96rem;
        padding: 0.26rem 0.44rem;
        font-size: 0.3rem;
        line-height: 0.42rem;
        &:nth-child(odd) {
            background-color: #f9f9f9;
        }
        &.active {
            color: rgba(226, 12, 12, 0.842);
            &::before {
                content: '\2714';
                position: relative;
                float: right;
            }
        }
    }
}
.search-address-null {
    padding-top: 0.32rem;
    span {
        display: inline-block;
        width: 100%;
        line-height: 0.96rem;
        padding: 0.26rem 0.44rem;
        font-size: 0.3rem;
        line-height: 0.42rem;
    }
}
.m-from {
    min-height: 7rem;
}
</style>

<style lang="scss">
.search-address-region {
    li {
        i {
            display: inline-block;
            color: $red;
            font-style: normal;
        }
    }
}
.area-list i {
    color: #dc1e32;
    font-style: normal;
}
.select-rel .sel-area {
    position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/range/index.vue